import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import redMinusIcon from '../../svgs/delete-bin-icon.svg';
import PageReadOnlyInput from './PageReadOnlyInputCopy.jsx'; 
import TableInput from './TableInputCopy.jsx'; 
import addIcon from '../../svgs/plus-icon.svg';
import TableDropdownWithObj from './TableDropdownWithObjCopy.jsx'; 
import { Button, TableCell, Typography } from '@mui/material';

const AddGroupRebateSetupRow = ({row, count, tableHeader}) =>{
    // get context from parent
    const { 
        groupSetupDataList, 
        setGroupSetupDataList, 
        feeCategoryList, 
        productTypeList, 
        billingRateList, 
        rebateInputTypeId, 
        groupSetupDataListLength, 
        setGroupSetupDataListLength, 
        groupSetupErrorList, 
        setGroupSetupErrorList,
        rebateSetupTypeList, 
        activeList
    } = useContext(PageContext);

    // set state
    const [statusList, setStatusList] = useState(['Active', 'Inactive']);
    const [setupId, setSetupId] = useState(count+1); // setup id will always be count+1 (this is for adding identity column into database if master tier for another row)
    const [rateTag, setRateTag] = useState('Rate'); 

    // add row from data list
    const addRebateSetup = () =>{
        // create header object
        let temp2 = []; 
        for (let i = 0; i < tableHeader.length; i++){
            temp2.push(tableHeader[i]['columnname']);
        }
        // get most recent row 
        let prevRow = null; 
        for (let i = count - 1; i >= 0; i--) {
            if (groupSetupDataList[i]) {
                prevRow = groupSetupDataList[i]; 
            }
        }
        // if there is a previous row get sub company id, master tier id, product, fee category, billing rate and days to pay from that row 
        let temp;
        if (prevRow){
            // build object
            temp2.map((el) => {
                if (el == 'blank'){
                    temp = {...temp, [el]: false};
                }
                else if (el == 'active'){
                    temp = {...temp, [el]: activeList[0]};
                }
                else if (el == 'producttypeid'){ 
                    temp = {...temp, [el]: prevRow['producttypeid']};
                }
                else if (el == 'feecategoryid'){
                    temp = {...temp, [el]: prevRow['feecategoryid']}; 
                }
                else if (el == 'billingrateid'){
                    temp = {...temp, [el]: prevRow['billingrateid']}; 
                }
                else if (el == 'incentivesetupid') {
                    temp = {...temp, [el]: count+1};
                }
                else if (el == 'rebatesetuptypeid') {
                    temp = {...temp, [el]: prevRow['rebatesetuptypeid']}; 
                }
                else {
                    temp = {...temp, [el]: ''};
                }
            }); 
        }
        // if no previous row all values are default 
        else{
            // build object
            temp2.map((el) => {
                if (el == 'blank'){
                    temp = {...temp, [el]: false};
                }
                else if (el == 'active'){
                    temp = {...temp, [el]: activeList[0]};
                }
                else if (el == 'feecategoryid' || el == 'producttypeid' || el == 'billingrateid' ){
                    temp = {...temp, [el]: null};
                } 
                else if (el == 'incentivesetupid') {
                    temp = {...temp, [el]: count+1};
                }
                else{
                    temp = {...temp, [el]: ''};
                }
            });
        }
        // assign object to state 
        let tempObj = groupSetupDataList; 
        // move bottom row to end of object
        tempObj[(count+1)] = groupSetupDataList[count]; 
        // set new element 
        groupSetupDataList[count] = temp; 
        setGroupSetupDataList(groupSetupDataList => groupSetupDataList = tempObj);
        // set error object 
        let temp5 = {}
        Object.keys(temp2).map((el) => {
            temp5 = {
                ...temp5, 
                el: false, 
            }
        }); 
        // add error object to sub company error list 
        setGroupSetupErrorList(groupSetupErrorList => groupSetupErrorList = [
            ...groupSetupErrorList.slice(0, groupSetupErrorList.length-1), 
            temp5, 
            ...groupSetupErrorList.slice(groupSetupErrorList.length-1, groupSetupErrorList.length)
        ]); 
        // increment length
        setGroupSetupDataListLength(groupSetupDataListLength => groupSetupDataListLength = groupSetupDataListLength + 1); 
    }

    // remove row from data list 
    const removeRebateSetup = (index) =>{
        // set tempObj 
        let tempObj = groupSetupDataList; 
        // remove row at index
        let length = 0; 
        Object.keys(tempObj).map(el => {
            let num = parseInt(el); 
            // set length; 
            length = num; 
            // overwrite element
            if ( tempObj[(num+1)] && num >= index) {
                tempObj[num] = tempObj[(num+1)]; 
                // update incentivesetupid 
                if (tempObj[num]['blank'] == false) {
                    tempObj[num]['incentivesetupid'] = num+1; 
                }   
            }
        }); 
        // remove last element 
        delete tempObj[length]; 
        // set state
        setGroupSetupDataList(groupSetupDataList => groupSetupDataList = tempObj); 
        // remove error object from error list
        setGroupSetupErrorList(groupSetupErrorList => groupSetupErrorList = [...groupSetupErrorList.slice(0, index), ...groupSetupErrorList.slice(index + 1, groupSetupErrorList.length)]); 
        // decrement length
        setGroupSetupDataListLength(groupSetupDataListLength => groupSetupDataListLength = groupSetupDataListLength - 1); 
    }

    // showCell for to determine how to display each column
    const showCell = ( el ) =>{
        if (el == 'blank'){
            if (row[el] == true){
                return <TableCell colSpan={tableHeader.length} align='center' className='p-2 bg-white'>
                        <Button disableRipple onClick={()=>addRebateSetup()} 
                            sx={{width:'100%', background:'#E5F2F6' ,border:'#E5F2F6','&:hover': {
                                backgroundColor: '#D9ECF2',
                                },
                                }}
                            >
                            {<div className='d-flex gap-2 align-items-center p-1'>
                                <img src={addIcon}/>
                                <Typography sx={{
                                    textTransform:'none',
                                    color:'#001317',
                                    fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',
                                    fontSize:'12px',
                                    lineHeight:'16px',
                                    fontWeight:'400'}}>
                                        {'Add'}
                                </Typography>
                            </div>}
                        </Button>
                        </TableCell>
            }
            else{
                return <TableCell><img src={redMinusIcon} class='data-table-icon-right' onClick={()=>removeRebateSetup(count)}/></TableCell>
            }
        } 
        else if (row['blank'] == false && el == 'active'){
            return <TableCell><TableDropdownWithObj tag='Status' objKey='active' count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} optionsList={activeList} width='7vw'  showError={groupSetupErrorList[count]['active']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'incentivesetupid'){
            return <TableCell><PageReadOnlyInput tag='ID' value={setupId} width='40px' /></TableCell>
        }
        else if (row['blank'] == false && el == 'producttypeid'){
            return <TableCell><TableDropdownWithObj tag='Product' objKey='producttypeid' count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} optionsList={productTypeList} width='7vw'  showError={groupSetupErrorList[count]['producttypeid']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'feecategoryid'){
            return <TableCell><TableDropdownWithObj tag='Fee Category' objKey='feecategoryid' count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} optionsList={feeCategoryList} width='7vw'  showError={groupSetupErrorList[count]['feecategoryid']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'billingrateid'){
            return <TableCell><TableDropdownWithObj tag='Billing Rate' objKey='billingrateid' count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} optionsList={billingRateList} width='7vw'  showError={groupSetupErrorList[count]['billingrateid']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'minspend'){
            return <TableCell><TableInput tag='Tier Min' objKey={'minspend'} count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} width='9.5vw'  showError={groupSetupErrorList[count]['minspend']} /></TableCell>
        }
        else if (row['blank'] == false && el == 'maxspend'){
            return <TableCell><TableInput tag='Tier Max' objKey={'maxspend'} count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} width='9.5vw'  showError={groupSetupErrorList[count]['maxspend']} /></TableCell>
        }
        else if (row['blank'] == false && el == 'incentiverate'){
            return <TableCell><TableInput tag={rateTag} objKey={'incentiverate'} count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} nullifyEmpty={true} width='7vw'  showError={groupSetupErrorList[count]['incentiverate']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'rebatesetuptypeid') {
            return <TableCell><TableDropdownWithObj tag='Setup Type' objKey='rebatesetuptypeid' count={count} list={groupSetupDataList} setList={setGroupSetupDataList} length={groupSetupDataListLength} optionsList={rebateSetupTypeList} width='7vw'  showError={groupSetupErrorList[count]['rebatesetuptypeid']}/></TableCell>
        }
        else {
            return <>{row[el]}</>
        }
    }

    // useEffect for rebateInputTypeId change
    useEffect(() => {
        console.log(rebateInputTypeId); 
        if (rebateInputTypeId == 1){
            setRateTag(rateTag => rateTag = 'Rate (%)'); 
        }
        else {
            setRateTag(rateTag => rateTag = 'Rate '); 
        }
    }, [rebateInputTypeId]); 

    return( 
        <>
            {/* map show cell function over every column */}
            {tableHeader.map(el => 
                showCell(el['columnname'])
            )}
        </>
    );
}

export default AddGroupRebateSetupRow;